import type { ResourceId } from '@wwf/sdk';

export type SignUpData = {
    email: string;
    password: string;
    first_name: string;
    last_name: string;
};

export type RAFile = {
    src: string;
    title: string;
    path?: string;
    rawFile: File;
    type?: string;
};

type ResourceInputPayload<
    InputKey extends string,
    IdKey extends string,
> = Partial<Record<InputKey, RAFile> & Record<IdKey, ResourceId | null>>;

function toResourceInputPayload<InputKey extends string, IdKey extends string>(
    payload: Record<string, RAFile | ResourceId | null>
): ResourceInputPayload<InputKey, IdKey> {
    return payload as unknown as ResourceInputPayload<InputKey, IdKey>;
}

export function resourceInputPayload<
    InputKey extends string,
    IdKey extends string,
>(
    keys: { inputKey: InputKey; idKey: IdKey },
    resourceInput: RAFile | null | undefined,
    resourceId: ResourceId | null | undefined
): ResourceInputPayload<InputKey, IdKey> {
    if (resourceInput != null && resourceInput.rawFile != null) {
        return toResourceInputPayload({ [keys.inputKey]: resourceInput });
    }
    if (resourceInput === null) {
        return toResourceInputPayload({ [keys.idKey]: null });
    }
    if (resourceId != null) {
        return toResourceInputPayload({ [keys.idKey]: resourceId });
    }
    return {};
}

export function isRaFile(file: unknown): file is RAFile {
    return (
        typeof file === 'object' &&
        file !== null &&
        'rawFile' in file &&
        'src' in file
    );
}
